module.exports = __webpack_public_path__ + "2cf2a53fbeeb82df7e6502d2552d9b45.pdf";